module.exports = __webpack_public_path__ + "img/audioIcon1.d41474d2.png";